import { render, staticRenderFns } from "./AgendaAppointments.vue?vue&type=template&id=47d66eeb&scoped=true"
import script from "./AgendaAppointments.vue?vue&type=script&lang=js"
export * from "./AgendaAppointments.vue?vue&type=script&lang=js"
import style0 from "./AgendaAppointments.vue?vue&type=style&index=0&id=47d66eeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d66eeb",
  null
  
)

export default component.exports